<!--
 * @Author: wzh
 * @LastEditTime: 2024-10-14 11:56:58
 * @Description: 忘记密码 设置密码
-->
<template>
  <div>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item :label="$t('login.activate.account')">
        <div style="text-align: left">
          <span style="color: var(--primary-color)"> {{ form.username }} </span>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('base.password.new')" prop="password">
        <a-input-password
          :placeholder="$t('base.password.new_placeholder')"
          v-model="form.password"
          :maxLength="32"
        />
        <span class="mm-qd"
          >{{ $t("base.password.strength") }}: {{ strength }}</span
        >
      </a-form-model-item>
      <a-form-model-item
        :label="$t('base.password.new_confirm')"
        prop="password2"
      >
        <a-input-password
          :placeholder="$t('base.password.new_confirm_placeholder')"
          v-model="form.password2"
          :maxLength="32"
        />
      </a-form-model-item>
    </a-form-model>

    <div class="next">
      <a-button style="width: 440px" type="primary" @click="handleNext">{{
        $t("base.btn.sure")
      }}</a-button>
    </div>
  </div>
</template>

<script>
import { commonAPI } from "@/apis";
import { PasswordStrength } from "@/mixins/password";

export default {
  mixins: [PasswordStrength],
  /*
  safeParams:{
		业务类型:businessClassify: this.type == "activate" ? "account_active" : this.type == "forget" ? "retrieve_password" : "change_phone_email",
		验证码值:captcha: "",
		邮件还是短信:noticeClassify, 
	}
  */
  props: ["safeParams"],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value != "") {
        let reg1 = escape(value).includes("%u"); // 是否包含中文字符、汉字
        let reg2 = new RegExp(/\s+/g); // 是否包含空格
        if (reg1 || reg2.test(value)) {
          callback(new Error(this.$t("base.password.format_error")));
        }
        if (this.form.password2) {
          this.$refs.form.validateField("password2");
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value != "") {
        if (value !== this.form.password) {
          callback(new Error(this.$t("base.password.again_error")));
        } else {
          callback();
        }
      }
    };

    return {
      pswSetInfo: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {
        username: "",
        secretKey: "",
        password: "",
        password2: "",
        passwordStrength: "1",
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t("base.password.new_placeholder"),
            whitespace: true,
          },
          { validator: validatePass },
        ],
        password2: [
          {
            required: true,
            message: this.$t("base.password.new_confirm_placeholder"),
            whitespace: true,
          },
          { validator: validatePass2 },
        ],
      },
    };
  },
  created() {
    let obj = JSON.parse(localStorage.getItem("FORGET_INFO"));
    this.form = Object.assign({}, obj);
    this.getPswSet();
  },
  methods: {
    // 获取密码策略
    async getPswSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/pass/get"
      );
      if (code == 0) {
        this.pswSetInfo = { ...data };
      } else {
        this.$message.error(message);
      }
    },
    // 下一步
    handleNext() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = this.pswSetInfo;
          let length = this.form.password.length;
          if (obj.mmcl == 1 && length < obj.zlrmmgzcd) {
            this.$message.warning(
              `${this.$t("base.password.length_tip")}: ${obj.zlrmmgzcd}`
            );
            return;
          }
          if (
            obj.mmcl == 2 &&
            (length < obj.tjrmmgzcd || !this.form.passwordStrength)
          ) {
            this.$message.warning(
              `${this.$t("base.password.length_tip")}: ${obj.tjrmmgzcd} ${
                this.dissatisfyMsg
                  ? `,${this.$t("base.password.includes_tip")}${
                      this.dissatisfyMsg
                    }`
                  : ""
              }`
            );
            return;
          }
          let params = {
            username: this.form.username,
            password: this.form.password,
            secretKey: this.form.secretKey,
            passwordStrength: this.form.passwordStrength,
            ...this.safeParams,
          };
          this.handleNextApi(params);
        } else {
          return false;
        }
      });
    },
    async handleNextApi(params) {
      const { code, message } = await commonAPI.postAction(
        // "/user/active/changePassword",
        "/user/active/changePasswordNew",
        params
      );
      if (code == 0) {
        // this.$message.success(message);
        this.$emit("next", 3);
      } else {
        this.$message.error(message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.next {
  text-align: center;
  padding-top: 20px;
}

.mm-qd {
  position: absolute;
  right: 0;
  translate: calc(100% + 10px);
  color: var(--primary-color);
}
</style>
